import script from "./DashboardsSubsidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardsSubsidebar.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardsSubsidebar.vue?vue&type=style&index=0&id=a3b3821c&lang=scss"

const __exports__ = script;

export default __exports__